module.exports = __webpack_public_path__ + "static/img/Ecospective.2fed49eb.jpeg";